import React, { useEffect, useState, useRef } from 'react';

import MapboxGl from 'mapbox-gl';
import { connect } from 'react-redux';

import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';

import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import AddIcon from '../../assets/img/add.svg';
import EditIcon from '../../assets/img/edit.svg';
import DeleteIcon from '../../assets/img/save.svg';
import * as actionTypes from '../../store/actions/index';
import './DisplayLocations.css';

const DisplayLocations = (props) => {
  const [geocoder, setgeocoder] = useState();
  const [IsLocationEditing, setIsLocationEditing] = useState(false);
  const [disabled, setIsDisabled] = useState(false);
  const [location, setLocation] = useState('');
  const ref = useRef();

  const { clientCurrentLocation } = props;

  useEffect(() => {
    MapboxGl.accessToken = process.env.REACT_APP_MAPBOX_KEY.trimEnd();
    const geocoder = new MapboxGeocoder({
      // Initialize the geocoder
      accessToken: MapboxGl.accessToken, // Set the access token
      mapboxgl: MapboxGl, // Set the mapbox-gl instance
      marker: false, // Do not use the default marker style
      placeholder: 'Please add the location', // Placeholder text for the search bar,
    });

    if (ref.current) {
      geocoder.addTo(ref.current);

      geocoder.on('result', async (ev) => {
        setIsDisabled(false);
        setLocation(ev.result.place_name);
      });
      geocoder.on('clear', async (ev) => {
        setLocation('');
      });
      setgeocoder(geocoder);
    }
  }, []);

  useEffect(() => {
    if (clientCurrentLocation?.length > 2 && ref.current.style.display === 'block') {
      geocoder.setInput(clientCurrentLocation);
      setLocation(clientCurrentLocation);
    }
    // eslint-disable-next-line
  }, [clientCurrentLocation, IsLocationEditing]);

  const addLocationHandler = () => {
    props.updateLocation(location);
    setIsLocationEditing(false);
  };
  const editLocationHandler = () => {
    setIsLocationEditing(true);
  };
  const saveLocationHandler = () => {
    props.updateLocation(location);
    setIsLocationEditing(false);
  };
  const hoverHandler = () => {
    props.currentLocHovered();
  };
  const hoverRemoveHandler = () => {
    props.remove();
  };

  return (
    <div>
      <h4 style={{ color: '#1A1A1A' }}>Location Options</h4>
      <div>
        <div className="locationDiv">
          <h5 style={{ color: '#1A1A1A' }}>Your Location</h5>
          <div className="locBtnDiv">
            {clientCurrentLocation && clientCurrentLocation != 'null' ? (
              IsLocationEditing ? (
                <button className="btn" disabled={disabled} onClick={saveLocationHandler}>
                  <div>
                    <img src={AddIcon} />
                  </div>
                  <div>Save</div>
                </button>
              ) : (
                <button className="btn" onClick={editLocationHandler}>
                  <div>
                    <img src={EditIcon} />
                  </div>
                  <div>Edit</div>
                </button>
              )
            ) : (
              <button className="btn" onClick={addLocationHandler} disabled={disabled}>
                <div>
                  <img src={AddIcon} />
                </div>
                <div>Add</div>
              </button>
            )}
          </div>
        </div>

        <div
          className={`clocation ${!IsLocationEditing && clientCurrentLocation && 'clocationHover'}`}
        >
          <div className="locationLine"></div>
          <div className="currentLocationCircle"></div>

          <h5
            className="clocname"
            onMouseEnter={hoverHandler}
            onMouseLeave={hoverRemoveHandler}
            style={{
              display:
                clientCurrentLocation && clientCurrentLocation != 'null' && !IsLocationEditing
                  ? 'flex'
                  : 'none',
              fontSize: '16px',
            }}
          >
            {clientCurrentLocation}
          </h5>

          <div
            id="geocoder3"
            ref={ref}
            className="geocoder geocoder3"
            style={{
              width: '100%',
              zIndex: '10',
              display: clientCurrentLocation && !IsLocationEditing ? 'none' : 'block',
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    data: state.optRed.data,
    clientCurrentLocation: state.comRed.displayCurrentLocation,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateLocation: (location) => dispatch(actionTypes.updateLocation(location)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DisplayLocations);
